/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.area-navigation-container {
  display: flex;
  justify-content: center;
  background-color: white;
  @include mixins.use-available-space;
  margin-left: 20px;
  margin-right: 20px;

  .MuiButtonGroup-root {
    border-radius: 20px;
    box-shadow: none;
    padding: 3px;
    background-color: variables.$color-corpuls-secondary-50;
    flex-wrap: wrap;

    button {
      background-color: variables.$color-corpuls-secondary-50;
      color: black;
      font-weight: normal;
      border: none;
      border-radius: 50px;
      max-width: 200px;

      &:hover {
        background-color: variables.$color-white;
      }
      p {
        font-size: small;
      }
    }
  }
}
